<script setup lang="ts">
const route = useRoute()
const { locale } = useI18n()
const { appName } = useAppName()
const { initTheme } = useTheme()
initTheme()

/**
 * Global head configuration
 * @see https://unhead.harlanzw.com/
 * @see https://github.com/unjs/unhead/tree/main
 */
useHead({
  title: route.meta.title || '',
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} - ${appName.value}` : appName.value
  },
  htmlAttrs: {
    lang: locale.value,
  },
})

// Used to trigger full page rerenders when switches organizations
// This is mainly done because most form inits aren't fully reactive.
// I guess doing a redirect would be a bit safer, since the user can still, end up on a page that
// shouldn't be accessible for the current context.
const { selectedOrganization } = storeToRefs(useCurrentOrganizationStore())
</script>

<template>
  <div>
    <NuxtLayout>
      <NuxtLoadingIndicator color="var(--color-primary-500)" />
      <NuxtErrorBoundary>
        <NuxtPage :key="selectedOrganization?.id" />
        <template #error="{ error }">
          <AppError :error="error" />
        </template>
      </NuxtErrorBoundary>
    </NuxtLayout>
    <ToasterContainer />
    <AppPanels />
  </div>
</template>
